"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
function updateUnitsCompletedForNonLeafNode(state, user, childrenContentIds, allStates) {
    const childrenStates = getState_1.getStatesForUserIdAndContentIds(allStates, childrenContentIds, user.userId);
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    let unitsCompleted = 0;
    childrenContentIds.forEach((childContentId) => {
        const childState = childrenStatesByContentId[childContentId];
        if (childState.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            unitsCompleted += 1;
        }
    });
    state.unitsCompleted = unitsCompleted;
}
exports.updateUnitsCompletedForNonLeafNode = updateUnitsCompletedForNonLeafNode;
//# sourceMappingURL=updateUnitsCompletedForNonLeafNode.js.map